(function () {
  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function imageProxyUrl(apiUrl, imageUrl) {
    if (!apiUrl || !imageUrl) return '';
    var base = apiUrl.replace(/\/$/, '');
    return base + '/image?url=' + encodeURIComponent(imageUrl);
  }

  function renderPost(post, iconUrl, apiUrl) {
    var image = escapeHtml(imageProxyUrl(apiUrl, post.image));
    var link = escapeHtml(post.link);
    var icon = escapeHtml(iconUrl);

    return (
      '<a href="' +
      link +
      '" class="pss-instagram__item" target="_blank" rel="noopener noreferrer">' +
      '<span class="pss-instagram__frame">' +
      '<img class="pss-instagram__img" src="' +
      image +
      '" alt="Instagram post" loading="lazy" decoding="async" width="480" height="480">' +
      '<span class="pss-instagram__hover" aria-hidden="true">' +
      '<img class="pss-instagram__ig-icon" src="' +
      icon +
      '" alt="" width="32" height="32">' +
      '</span>' +
      '</span>' +
      '</a>'
    );
  }

  function initFeed(feedEl) {
    var apiUrl = feedEl.getAttribute('data-api-url');
    var username = feedEl.getAttribute('data-username');
    var limit = parseInt(feedEl.getAttribute('data-limit'), 10) || 6;
    var iconUrl = feedEl.getAttribute('data-icon-url');

    if (!apiUrl || !username) return;

    var requestUrl =
      apiUrl +
      (apiUrl.indexOf('?') >= 0 ? '&' : '?') +
      'username=' +
      encodeURIComponent(username) +
      '&limit=' +
      encodeURIComponent(String(limit)) +
      '&v=3';

    fetch(requestUrl)
      .then(function (response) {
        if (!response.ok) throw new Error('Feed request failed');
        return response.json();
      })
      .then(function (payload) {
        var posts = payload && payload.posts ? payload.posts : [];

        if (!posts.length) {
          throw new Error('No posts returned');
        }

        feedEl.innerHTML = posts.map(function (post) {
          return renderPost(post, iconUrl, apiUrl);
        }).join('');
        feedEl.setAttribute('aria-busy', 'false');
      })
      .catch(function () {
        feedEl.setAttribute('aria-busy', 'false');
        feedEl.innerHTML =
          '<p class="pss-instagram__error">Could not load Instagram posts right now. Please try again later.</p>';
      });
  }

  function initAll() {
    document.querySelectorAll('[data-pss-instagram-feed]').forEach(initFeed);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
